import Link from "next/link";
import { useRouter } from "next/router";

import stepper from "./stepper.module.css";

type Steps = {
  href?: string;
  label: string;
};

export type StepperProps = {
  steps: Steps[];
};

export const Stepper = ({ steps }: StepperProps) => {
  const { pathname, locale } = useRouter();

  return (
    <ol className={stepper.container}>
      {steps.map(({ href, label }: Steps, index) => {
        const current = pathname === href;
        const localised = locale ? `/${locale}${href}` : href;
        return (
          <li
            className={stepper.step}
            key={index}
            aria-current={current ? "step" : null}
          >
            <Link data-step={index + 1} href={localised}>
              {label}
            </Link>
          </li>
        );
      })}
    </ol>
  );
};
